import { useEffect, useReducer, useRef } from 'react';
import { forEach } from 'lodash';

const fetchReducer = (state, action) => {
    const { type, data, headers } = action;

    switch (type) {
        case 'LOADING':
            return { ...state, loading: true };
        case 'SUCCESS':
            return { ...state, loading: false, data, headers };
        case 'ERROR':
            return { ...state, loading: false, error: data };
        default:
            return state;
    }
};

const useFetch = (url, options = {}, returnHeaders = []) => {
    const initialState = {
        data: null,
        headers: null,
        loading: false,
        error: null
    };

    const cache = useRef({});

    const [state, dispatch] = useReducer(fetchReducer, initialState);

    useEffect(() => {
        let cancelRequest = false;
        const fetchRequest = async () => {
            dispatch({ type: 'LOADING' });
            if (cache.current[url]) {
                const { data, headers } = cache.current[url];
                dispatch({ type: 'SUCCESS', data, headers });
            } else {
                try {
                    const response = await fetch(url, options);
                    const data = await response.json();
                    let headers = {};
                    if (returnHeaders.length) {
                        forEach(returnHeaders, (header) => {
                            headers[header] = response.headers.get(header);
                        });
                    }
                    cache.current[url] = { data, headers };
                    if (cancelRequest) return;
                    dispatch({ type: 'SUCCESS', data, headers });
                } catch (error) {
                    if (cancelRequest) return;
                    dispatch({ type: 'ERROR', data: error.message });
                }
            }
        };
        if (url) {
            fetchRequest();
        }

        return () => {
            cancelRequest = true;
        };
    }, [url]); //eslint-disable-line react-hooks/exhaustive-deps

    return state;
};

export default useFetch;
